let anchorlinks = document.querySelectorAll(".anchor-link");

if (anchorlinks) {
  anchorlinks.forEach((item) => {
    item.addEventListener("click", (evt) => {
      evt.preventDefault();
      let hashval = item.getAttribute("href");

      if (window.innerWidth > 769) {
        var topOfElement = document.querySelector(hashval).offsetTop - 80;
      } else {
        var topOfElement = document.querySelector(hashval).offsetTop - 80;
      }

      window.scroll({ top: topOfElement, behavior: "smooth" });
      history.pushState(null, null, hashval);
    });
  });
}
